/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import StatisticsCard from './StatisticsCard';
// import { statsData } from 'data/dashboard/saas';
import { forIn } from 'lodash';

const StatisticsCards = ({ statsData }) => {
  const data = [];
  forIn(statsData, (value, key) => {
    data.push({ title: key, suffix: '%', ...statsData[key] });
  });

  return (
    <Row className="g-3 mb-0">
      {data.map((item, index) => (
        <Col key={item.title} sm={6} md={6}>
          <StatisticsCard
            stat={item}
            style={{ minWidth: '12rem', height: '100%' }}
            index={index}
          />
        </Col>
      ))}
    </Row>
  );
};

export default StatisticsCards;
